// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteBtn_root__G7zd3"};